import { render, staticRenderFns } from "./StripBuilderQuestionStep.vue?vue&type=template&id=484919e2&scoped=true&"
import script from "./StripBuilderQuestionStep.vue?vue&type=script&lang=js&"
export * from "./StripBuilderQuestionStep.vue?vue&type=script&lang=js&"
import style0 from "./StripBuilderQuestionStep.vue?vue&type=style&index=0&id=484919e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484919e2",
  null
  
)

export default component.exports